// Черновите на „Инвентаризация" на началния екран и на таблото — общото
// `components/drafts/useHomeDrafts` с думите и картата на инвентаризацията:
// моята (от сървъра, а до BE без черновите — локалната в този браузър, в т.ч.
// започнатата преди сървърните чернови) и тези на колегите; заета → „Поеми
// редакцията". „Започни" за склад подава склада през въпроса (`startNew`).
import { useWarehouses } from "../../../../../hooks/useInventory";
import { useHomeDrafts } from "../../../components/drafts/useHomeDrafts";
import { DRAFT_TEXTS } from "../../../components/drafts/draftTexts";
import { STOCKTAKE_DRAFT_STORE, localStocktakeDraftSummary } from "../stocktakeDraft";

export const STOCKTAKE_NEW_PATH = "/inventory/stocktake/new";

export const useStocktakeHomeDrafts = () => {
  const { data: warehouses = [] } = useWarehouses();
  return useHomeDrafts({
    type: "stocktake",
    newPath: STOCKTAKE_NEW_PATH,
    local: STOCKTAKE_DRAFT_STORE,
    localSummary: (draft) => {
      const summary = localStocktakeDraftSummary(
        draft,
        (warehouseId) => warehouses.find((warehouse) => warehouse.id === warehouseId)?.name ?? null,
      );
      // складът на локалната — за реда на склада в „Последна инвентаризация"
      return summary ? { ...summary, warehouseId: draft.warehouseId } : null;
    },
    texts: DRAFT_TEXTS.stocktake,
  });
};
